export const prescriptionTypes = [
    {label: "Tablet", value: "TABLET"},
    {label: "Liquid", value: "LIQUID"},
    {label: "Other", value: "OTHER"},
];

export const sideEffects = [
    {label: "May experience vomiting", value: "VOMITING"},
    {label: "May experience diarrhea", value: "DIARRHEA"},
    {label: "May experience drowsiness", value: "DROWSINESS"},
]
